module.exports = __webpack_public_path__ + "static/2-902f1f1c732f7cc1b30b00300afdf169.jpg";